export const shouldPreserveRouteScroll = ({ pathname, previousPathname, search }) => {
  const params = new URLSearchParams(search);

  return (
    previousPathname === pathname &&
    pathname === '/nights' &&
    (params.has('highlightNight') || params.has('focusNightId'))
  );
};
